import { configureStore } from "@reduxjs/toolkit";
import projectReducer from "./reducer/projectSlice";

export const store = configureStore({
  reducer: {
    project: projectReducer,
  },
});
